angular.module 'app'
.controller 'MenuManagementCtrl', ($scope, $http, $stateParams, $state, config, Storage) ->
  $scope.permission = Storage.get('user_permission')

  $scope.ui =
    user: Storage.get('login_user')
